import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { menuConfig } from '../menuConfig';
import { all_routes } from 'core/data/routes/all_routes';
import SVGComponent from 'components/common/mediaRender/SVGComponent';
import SolidMenuItem from './elements/SolidMenuItem';
import ToggleMenuItem from './elements/ToggleMenuItem';

const MenuSection = ({ section }) => {
    return (
        <div className="menu-section">
            <h6>{section.tittle}</h6>
            <ul className="sidebar-menu">
                {section.menu.map((menu, idx) => (
                    menu.hasSubRoute ? (
                        <ToggleMenuItem key={menu.menuValue} menu={menu} />
                    ) : (
                        <SolidMenuItem key={idx} menu={menu} />
                    )
                ))}
            </ul>
        </div>
    );
};

const AdminSidebar = () => {
    const routes = all_routes;

    return (
        <aside className="admin-sidebar">
            <div className="logo-container">
                <Link to={routes.homeBannerSlider}>
                    <SVGComponent url="/assets/img/logo.svg" className="footer logo" style={{ width: '160px' }} onLoad={() => { }} />
                </Link>
            </div>
            <nav className="" style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 100px)' }}>
                {menuConfig.map((section, index) => (
                    <MenuSection key={index} section={section} />
                ))}
            </nav>
        </aside>
    );
}

export default memo(AdminSidebar);